import { useEffect } from "react";
import { loadDrivers } from "./ducks/data/drivers";
import { getClients } from "./ducks/data/clients";
import { getAll as getWebBookers } from "./ducks/data/web-bookers";
import { loadTrailers } from "./ducks/data/trailers";
import { useAppDispatch } from "./redux-store";
import { loadDepartments } from "./ducks/data/departments";
import { loadClientCargoTemplates } from "./ducks/data/client-order-templates";
import { loadOrgSettings } from "./ducks/data/org-settings";

const LoadStandardData = () => {
  // Render-less component. React pattern for e.g. triggering effects on
  // mounting, in this case loading initial data.
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(loadTrailers());
    dispatch(loadDrivers());
    dispatch(getClients());
    dispatch(getWebBookers());
    dispatch(loadDepartments());
    dispatch(loadClientCargoTemplates());
  }, [dispatch]);
  // Org settings gate whole parts of the UI (the equipment module, the rental
  // billing tab). They used to be loaded only by the dispatching page and the
  // settings page, so opening any other page directly left them at their
  // defaults and those parts stayed hidden.
  //
  // Its own effect with a `[dispatch]` dependency list, so it runs once per
  // mount.
  useEffect(() => {
    dispatch(loadOrgSettings());
  }, [dispatch]);
  return null;
};

export default LoadStandardData;
